.empty {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  align-items: flex-start;
  max-inline-size: var(--prose-max);
  padding: var(--space-4) 0 var(--space-8);
}

.empty[data-variant="inline"] {
  align-items: center;
  max-inline-size: none;
  padding: var(--space-6) var(--space-4);
  text-align: center;
}

.icon {
  display: inline-flex;
  margin-block-end: var(--space-2);
  color: var(--color-text-subtle);
}

.title {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
}

.empty[data-variant="inline"] .title {
  font-size: var(--text-lg);
}

.description {
  max-inline-size: var(--prose-max);
  color: var(--color-text-muted);
  font-size: var(--text-md);
  line-height: var(--leading-normal);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-block-start: var(--space-2);
}
